import { connect } from 'react-redux';

import UnsubscribeConfirmationScreen from '../components/UnsubscribeConfirmationScreen';

const _mapStateToProps = ({ organizationName }) => ({ organizationName });

const _mapPropsToDispatch = {};

export default connect(
    _mapStateToProps,
    _mapPropsToDispatch,
)(UnsubscribeConfirmationScreen);
